import React, {
  useCallback,
} from 'react'

import UINames from 'constants/ui-names'

import { useDisplayManager } from 'components/DisplayManager'
import { useTCF } from 'components/TCFProvider'

import LazyStandardConsentMessage from './LazyStandardConsentMessage'
import LazyTCFConsentMessage from './LazyTCFConsentMessage'


export default function ConsentMessage() {
  const { gvl } = useTCF()
  const { pushActiveUI } = useDisplayManager()

  const handleShowDocument = useCallback((docUrl) => {
    pushActiveUI(UINames.DOC_MODAL, {
      docUrl,
    })
  }, [pushActiveUI])

  const handleShowPreferences = useCallback(() => {
    pushActiveUI(UINames.PREFERENCES)
  }, [pushActiveUI])

  const Component = ( gvl ) ? LazyTCFConsentMessage : LazyStandardConsentMessage

  return (
    <Component
      handleShowDocument={ handleShowDocument }
      handleShowPreferences={ handleShowPreferences }
    />
  )
}
